"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UploadcareGroup = /** @class */ (function () {
    function UploadcareGroup(groupInfo, files) {
        this.storedAt = null;
        this.uuid = groupInfo.id;
        this.filesCount = groupInfo.filesCount;
        this.totalSize = Object.values(groupInfo.files).reduce(function (acc, file) { return acc + file.size; }, 0);
        this.isStored = !!groupInfo.datetimeStored;
        this.isImage = !!Object.values(groupInfo.files).filter(function (file) { return file.isImage; })
            .length;
        this.cdnUrl = groupInfo.cdnUrl;
        this.files = files;
        this.createdAt = groupInfo.datetimeCreated;
        this.storedAt = groupInfo.datetimeStored;
    }
    return UploadcareGroup;
}());
exports.UploadcareGroup = UploadcareGroup;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/tools/UploadcareGroup.js
// module id = 1264
// module chunks = 71